import React,{Component} from 'react';
import Head from './Head'
import Foot from './Foot'
import Grid from 'material-ui/Grid';
import  NovelCard from './NovelCard'
import  NewArticle from './NewArticle'
import { getJSON } from 'jquery'
import { CircularProgress } from 'material-ui/Progress';
import NovelContext from './NovelContext'
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';

class Blog extends Component{
constructor(){
    super();
    this.state={
        novelArray:[],
        load:false,
        context:false,
        contextId:-1

    }
}

handleContext(id){
    this.setState({
        context:true,
        contextId:id
    })
}
    handleCache(id){
        this.setState({
            context:false,
            contextId:id
        })
    }
handleUpdate(){
    this.setState({
        load:true
    })
    getJSON('http://123.207.90.121:8080/newBlog/api/getNovels').then(response=>{
        const data=response.data;
        if (response.code>=1){
            this.setState({
                novelArray:data
            })

        }else {
            this.handleLoginError();

        }
        return true;
    },error=> {
    }).then(flag=>{
        this.setState({
            load:false
        })
    })
}

    componentWillMount(){
        this.setState({
            load:true
        })
        getJSON('http://123.207.90.121:8080/newBlog/api/getNovels').then(response=>{
            const data=response.data;
            if (response.code>=1){
                this.setState({
                    novelArray:data
                })

            }else {
                this.handleLoginError();

            }
            return true;
        },error=> {
        }).then(flag=>{
            this.setState({
                load:false
            })
        })
    }



    render(){
        if (this.state.load){
            return (<table valign="medium" align="center" style={{width:'100%'}}>
                <tbody><tr><td align="center"><CircularProgress style={{color:'green'}} />
                </td></tr></tbody></table>)
        }

        return(
            <div id="cc" style={{height:'100%',overflow: 'auto'}}>
                <Head src='image/novelHeader.jpg' title='Novel' sentence='Red sand flows out,Sweet mouthThe, sky is painted in Lunacia' />
                <div style={{backgroundImage:'url(\'image/pageBackground.jpg\')',backgroundColor:'white',backgroundSize:'cover',padding:'50px 5% 50px',
                    backgroundPositionX:'center',
                    backgroundPositionY: 'top',
                    boxShadow: '0px 10px 10px 10px  #888888 inset',minHeight:'100%'
                }}>


                    <Grid  container spacing={24} style={{display:'flex',
                        flexDirection:'row-reverse',
                        flexWrap:'warp',
                        justifyContent:'flex-start'}}>
                        <Grid sm={1}item xs={12} md={1} />
                        <Grid sm={3}item xs={12} md={3}>
                            <NewArticle/>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7}>
                            {this.state.context?
                                <div >
                            <NovelContext id={this.state.contextId} />
                                <Grid item xs={12} sm={12}>
                                <Paper
                                style={{background: 'white',marginTop:'30px',textAlign:'center'}}>
                                <Button size="small" color="primary" onClick={this.handleCache.bind(this)}>
                                <i className="material-icons">cached</i>
                                </Button>
                                </Paper>
                                </Grid>
                                </div>
                            :
                                this.state.novelArray.map(
                                    (novel)=>{
                                        return(
                                            <NovelCard key={novel.novelId} handleUpdate={this.handleUpdate.bind(this)} handleContext={this.handleContext.bind(this)} novel={novel} />
                                        )
                                    }
                                )
                            }



                        </Grid>
                        <Grid sm={2} item/>



                    </Grid>




                </div>
                <Foot src='image/novelFooter.jpg'  sentence='There is no escape, my dear' info='© 2018 By Kayer'  />
            </div>
        )
    }
}
export default Blog;


// WEBPACK FOOTER //
// ./src/Compent/page/Novel.js